import * as React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    TextField,
    Button,
    Divider,
    Box
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useToken } from './items/UseToken';

export default function RobotExecuteForm({ handleClose }) {
    const { token } = useToken();

    // ===================== STATE =====================
    const [machineList, setMachineList] = useState([]);
    const [processList, setProcessList] = useState([]);

    const [machine, setMachine] = useState('');
    const [processId, setProcessId] = useState('');

    // 🔥 inputs z backendu (top-level)
    const [inputs, setInputs] = useState([]);
    const [argumentsMap, setArgumentsMap] = useState({});

    // ===================== LOAD DATA =====================
    useEffect(() => {
        fetch('api/getmachines', {
            headers: { Authorization: 'Bearer ' + token }
        })
            .then(res => res.json())
            .then(res => setMachineList(res.results || []));

        fetch('api/getrobots?is_active=1', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then(res => res.json())
            .then(res => {
                setProcessList(res.results || []);
                setInputs(res.inputs || []);

                // init argumentów defaultami
                const initialArgs = {};
                (res.inputs || []).forEach(input => {
                    initialArgs[input.key] = input.value ?? '';
                });
                setArgumentsMap(initialArgs);
            });
    }, [token]);

    // ===================== SUBMIT =====================
    const handleSubmit = () => {
        fetch('api/runjob', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify({
                machine,
                process_id: processId,
                arguments: argumentsMap
            })
        }).then(() => handleClose());
    };

    // ===================== RENDER =====================
    return (
        <Card sx={{ maxWidth: 720 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Run Process
                </Typography>

                <Grid container spacing={2}>
                    {/* MACHINE */}
                    <Grid item xs={12}>
                        <TextField
                            select
                            fullWidth
                            label="Machine"
                            value={machine}
                            onChange={(e) => setMachine(e.target.value)}
                            SelectProps={{ native: true }}
                        >
                            <option value="" disabled />
                            {machineList.map(m => (
                                <option key={m.guid} value={m.guid}>
                                    {m.name}
                                </option>
                            ))}
                        </TextField>
                    </Grid>

                    {/* PROCESS */}
                    <Grid item xs={12}>
                        <TextField
                            select
                            fullWidth
                            label="Process"
                            value={processId}
                            onChange={(e) => setProcessId(e.target.value)}
                            SelectProps={{ native: true }}
                        >
                            <option value="" disabled />
                            {processList.map(p => (
                                <option key={p.id} value={p.id}>
                                    {p.name} v{p.version}
                                </option>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>

                {/* ================= INPUTS ================= */}
                {processId && inputs.length > 0 && (
                    <>
                        <Divider sx={{ my: 3 }} />
                        <Typography variant="subtitle1" gutterBottom>
                            Process Inputs
                        </Typography>

                        <Grid container spacing={2}>
                            {inputs.map((input, i) => (
                                <Grid item xs={12} key={i}>
                                    <TextField
                                        fullWidth
                                        label={input.key}
                                        value={argumentsMap[input.key] ?? ''}
                                        onChange={(e) =>
                                            setArgumentsMap(prev => ({
                                                ...prev,
                                                [input.key]: e.target.value
                                            }))
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </>
                )}

                {/* ================= ACTIONS ================= */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 4
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!machine || !processId}
                    >
                        Start Job
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
}
